export default {
  isFetchPermissionInfo: false
};